import Icon, { IconName } from '@/components/Icon/Icon';
import ResponsiveImage from '@/components/Image/ResponsiveImage';
import { FrontifyImageContent } from '@/contentful';
import useGlobalStyles from '@/styles/global.styles';
import { PlaylistVideoCardCf } from '@/types';

import useStyles from './PlaylistVideoCard.styles';

export const PlaylistVideoCard = ({
  isOnDark,
  isPlaying,
  card,
  position,
  length,
  onThumbnailClick,
}: {
  isOnDark: boolean;
  isPlaying: boolean;
  card: PlaylistVideoCardCf;
  position: number;
  length: number;
  onThumbnailClick: () => void;
}) => {
  const { classes, cx } = useStyles({ isOnDark });
  const { classes: globalClasses } = useGlobalStyles({ fixed: true });
  const [thumbnail] = card.fields.thumbnail as unknown as [
    FrontifyImageContent
  ];

  return (
    <button
      className={classes.card}
      onClick={onThumbnailClick}
      aria-label={`${isPlaying ? 'Pause' : 'Play'} ${
        card.fields.headline
      } video`}
    >
      <div
        className={cx(classes.thumbnail, {
          [classes.thumbnailPlaying]: isPlaying,
        })}
      >
        {thumbnail && (
          <ResponsiveImage
            src={thumbnail}
            alt={thumbnail.title}
            className={classes.image}
            sizes={{ xs: 200, md: 288 }}
          />
        )}
        <Icon
          className={classes.playerControl}
          name={isPlaying ? IconName.PAUSE_SQUARE : IconName.PLAY_SQUARE}
          width={80}
        />
      </div>
      <h4 className={cx(globalClasses.h4Hyperlink, classes.headline)}>
        {card.fields.headline}
      </h4>
      <span className={cx(globalClasses.eyebrow, classes.videoPosition)}>
        {position} of {length}
      </span>
    </button>
  );
};
